import AntdTitle from 'antd/es/typography/Title';

const Title = ({...props}) => <AntdTitle {...props}/>;

export default Title;
